import Slider from "../components/Slider";
import Herosection from "../components/Herosection";
import Whatwedo from "../components/Whatwedo";

import Achievement from "../components/Achievement";
import { motion } from "framer-motion";

const scrollAnimation = {
  hidden: {
    opacity: 0,
    y: 80, // bottom to top
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: "easeOut",
    },
  },
};

const Home = () => {
  return (
    <div className="bg-[#d9f0ea]">
      <motion.div
        variants={scrollAnimation}
        initial="hidden"
        whileInView="visible"
        viewport={{ amount: 0.2 }} // triggers both directions
      >
        <Slider />
      </motion.div>

      <motion.div
        variants={scrollAnimation}
        initial="hidden"
        whileInView="visible"
        viewport={{ amount: 0.2 }}
      >
        <Herosection />
      </motion.div>

       <motion.div
        variants={scrollAnimation}
        initial="hidden"
        whileInView="visible"
        viewport={{ amount: 0.2 }}
      >
        <Achievement />
      </motion.div>

      <motion.div
        variants={scrollAnimation}
        initial="hidden"
        whileInView="visible"
        viewport={{ amount: 0.2 }}
      >
        <Whatwedo />
      </motion.div>

    
      
    </div>
  );
};

export default Home;